import { render, staticRenderFns } from "./ProjectSharing.vue?vue&type=template&id=558e6052&scoped=true&"
import script from "./ProjectSharing.vue?vue&type=script&lang=js&"
export * from "./ProjectSharing.vue?vue&type=script&lang=js&"
import style0 from "./ProjectSharing.vue?vue&type=style&index=0&id=558e6052&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558e6052",
  null
  
)

export default component.exports